import { CookieKeys, useIntl } from '@finn/auto-ui/utils/array';
import { Button } from '@finn/design-system/atoms/button';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@finn/design-system/atoms/modal';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@finn/design-system/atoms/tooltip';
import { Check } from '@finn/design-system/icons/check';
import { VehicleContext } from '@finn/ua-vehicle';
import cookies from 'js-cookie';
import { useRouter } from 'next/navigation';
import { useContext, useState } from 'react';

export const CategoryFakeDoorModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const i18n = useIntl();
  const { push } = useRouter();
  const { vehicle } = useContext(VehicleContext);
  const [isCopied, setIsCopied] = useState(false);

  const voucherCode = 'KATEGORIE';
  const copyVoucherCode = () => {
    navigator.clipboard.writeText(voucherCode);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  const toPLP = () => {
    const plpLink = (vehicle as any).fake_door_filters;
    cookies.set(CookieKeys.CATEGORY_FAKE_DOOR_CLOSED, 'true');

    push(`/subscribe/${plpLink}?sort=asc`);
  };

  return (
    <Modal
      variant="small"
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
    >
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Wir arbeiten dran!</ModalTitle>
        </ModalHeader>
        <p className="body-16-light">
          Vielen Dank für dein Interesse an unserem Kategorie-Abo. Aktuell
          prüfen wir, ob wir die Option zukünftig anbieten.
        </p>

        <p className="body-16-light">
          Als Dankeschön schenken wir dir einen <strong>10-€-Gutschein</strong>.
          Gib einfach den folgenden Code im letzten Schritt deiner Bestellung
          ein, um den Rabatt auf Ihren ersten Abo-Monat zu erhalten:
        </p>
        <div className="flex flex-row items-center justify-between rounded-sm border border-solid border-pearl px-4 py-3">
          <span className="body-16-regular">{voucherCode}</span>

          <Button
            className="uppercase focus:bg-white"
            variant="ghost"
            size="md"
            onClick={copyVoucherCode}
          >
            {isCopied ? (
              <span className="flex flex-row items-center gap-2">
                <Tooltip defaultOpen>
                  <TooltipTrigger>
                    <Check className="fill-trustedBlue" />
                  </TooltipTrigger>
                  <TooltipContent
                    body={i18n.formatMessage('pdp.36Term.fakedoor.copied')}
                  />
                </Tooltip>
              </span>
            ) : (
              i18n.formatMessage('pdp.36Term.fakedoor.copy')
            )}
          </Button>
        </div>
        <ModalFooter>
          <Button size="lg" className="w-full" onClick={toPLP}>
            Verfügbare Modelle anzeigen
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
